export const title = "tajl9hu";
export const navigationLinksContainer = "nul23pp";
export const navigationLink = "n1dknaby";
export const chatInput = "c1td2p5l";
export const sendButton = "svpagmk";
export const disabledButton = "d1n0fz23";
export const inputContainer = "ixmj2js";
export const fullWidth = "fjq0980";
export const instructionsContainer = "i1jcth2l";
export const instructionsHeader = "i1qxcyta";
export const gridContainer = "gcerldc";
export const pageInstructionsHeader = "p1wdabhl";
export const showMoreButton = "sh3e3z0";
export const showDialogButton = "scm26rs";

require("./style.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");